import jsonApiFetch from 'utils/jsonApiFetch'

const logActivity = async (orgDatabaseId, body) => {
  jsonApiFetch('POST', `/organizations/${orgDatabaseId}/log_activity`, body)
}

export default logActivity
